import { render, staticRenderFns } from "./FormGetPhoneNumber.vue?vue&type=template&id=471a8dc4&scoped=true&"
import script from "./FormGetPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./FormGetPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./FormGetPhoneNumber.vue?vue&type=style&index=0&id=471a8dc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471a8dc4",
  null
  
)

export default component.exports